import { FETCH_LIST_ITEMS as fetchListItems } from "../../../../../graphql/query/ListItems";
import { SelectList } from "../../../../../components/Functional";
import { useNavigate } from "react-router-dom";
import { LIST_TYPES } from "../../../../../constants/listTypes";

const Actions = props => {
  const { listId, workingListId } = props || {};
  const navigate = useNavigate();

  return (
    <div className="grid grid-flow-col gap-4">
      <SelectList.RemoveSelected {...props} />
      <SelectList.ClearList {...props} listId={listId || workingListId} />
      {listId ? (
        <SelectList.ExitEditMode
          onSuccess={() => (
            props?.onSuccess?.(), navigate("/offer?status=selectListSaved")
          )}
        />
      ) : (
        <SelectList.SaveList
          {...{
            ...props,
            typeId: LIST_TYPES.OFFER,
            onSuccess: () => (
              props?.onSuccess?.(), navigate("/offer?status=selectListSaved")
            ),
          }}
        />
      )}
    </div>
  );
};

const tableProps = props => {
  const { listId, workingListId } = props || {};
  // Prioritize listId (saved list) over workingListId (working list)
  const finalListId = listId || workingListId;

  const tableProps = {
    dataKey: "listItems",
    fetchPolicy: "network-only",
    FETCH_QUERY: fetchListItems({
      item: {
        artwork: { title: true, artists: {}, imagesSummary: { imgT: {} } },
        currency: {},
        status: {},
      },
    }),
    skip: () => !finalListId,
    variables: {
      listId: finalListId,
    },
  };

  return tableProps;
};

export { Actions, tableProps };
